module.exports = __webpack_public_path__ + "img/promo-3-mock.c5654f0f.png";